'use client';
import type { ReactNode } from 'react';
import { cn } from '@/app/utils';
import type { ActiveTabType } from './Payment';

interface PaymentTabsProps {
  tabs: { key: ActiveTabType; label: string; onClick: () => void }[];
  activeTab: ActiveTabType;
  trailingContent?: ReactNode;
}

export const PaymentTabs = ({ tabs, activeTab, trailingContent }: PaymentTabsProps) => {
  return (
    <div className="mt-6 flex items-center justify-between border-system-white08 border-b px-4 sm:flex-col sm:items-stretch sm:gap-3 sm:border-b-0 sm:px-4">
      <div className="flex items-center sm:w-full sm:justify-between">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <div
              key={tab.key}
              className={cn(
                'relative cursor-pointer px-6 py-4 text-base text-white transition-opacity',
                isActive ? 'font-semibold' : 'font-normal opacity-[0.64] hover:opacity-[0.88]',
              )}
              onClick={tab.onClick}
            >
              {tab.label}
              {isActive && <div className="-bottom-px absolute inset-x-0 h-0.5 bg-white" />}
            </div>
          );
        })}
      </div>
      {trailingContent && <div className="sm:self-end">{trailingContent}</div>}
    </div>
  );
};
